export const PAYMENT_OVERDUE_CTA_ROUTE = '/pending-payment/dues-payment';

/* the support number is unconfirmed — it may end up on the
   payment API payload or in per-restaurant config rather than here.
   Kept as one constant so swapping the source is a single change. */
export const SUPPORT_WHATSAPP_NUMBER = '';

export type PaymentOverdueCopy = {
  TITLE: string;
  IMP_MESSAGE: string;
  DEACTIVATED: string;
  DOWNLOAD_RECEIPT: string;
  MEMBERSHIP: string;
  DESCRIPTION_LINE_1: string;
  DESCRIPTION_LINE_2: string;
  OPERATIONS_UNAFFECTED: string;
  AMOUNT_DUE: string;
  PAY_NOW: string;
  CONTACT_US: string;
};

/* Copy lives here because this component is embedded in isolate
   TranslateModules (reports / analytics). Those loaders never see
   payment-overdue/*.json, so fallbackTranslate shows raw keys. */
export const PAYMENT_OVERDUE_COPY: Record<string, PaymentOverdueCopy> = {
  en_US: {
    TITLE: 'Feature is unavailable',
    IMP_MESSAGE: 'Important Message',
    DEACTIVATED: 'Deactivated',
    DOWNLOAD_RECEIPT: 'Download Receipt',
    MEMBERSHIP: 'ee_membership',
    DESCRIPTION_LINE_1:
      'Access is temporarily unavailable as your payment is overdue.',
    DESCRIPTION_LINE_2:
      'Please settle the outstanding amount to restore access.',
    OPERATIONS_UNAFFECTED: 'Your orders and POS operations are not affected.',
    AMOUNT_DUE: 'Amount due',
    PAY_NOW: 'Pay Now',
    CONTACT_US: 'Talk to us on WhatsApp',
  },
  id_ID: {
    TITLE: 'Fitur tidak tersedia',
    IMP_MESSAGE: 'Pesan Penting',
    DEACTIVATED: 'Dinonaktifkan',
    DOWNLOAD_RECEIPT: 'Unduh Tanda Terima',
    MEMBERSHIP: 'ee_membership',
    DESCRIPTION_LINE_1:
      'Akses dinonaktifkan sementara karena pembayaran Anda telah jatuh tempo.',
    DESCRIPTION_LINE_2:
      'Silakan lunasi tagihan Anda untuk memulihkan akses.',
    OPERATIONS_UNAFFECTED:
      'Pesanan dan operasional POS Anda tidak terpengaruh.',
    AMOUNT_DUE: 'Jumlah tagihan',
    PAY_NOW: 'Bayar Sekarang',
    CONTACT_US: 'Hubungi kami di WhatsApp',
  },
};
